<template>
<main>
    <div class="G_DisplayColumnNowrap L_PopupHolder" v-if="ProductInfoData">
        <div class="G_DisplayRowNowrap G_HeadingFont L_PopupHeading">
            <div class="G_DisplayRowNowrap L_PopupHeading">
                <div class="G_DisplayRowNowrap L_ProductHeading">{{ ProductInfo.Description }}</div>
                <div class="L_CloseButton" @click="close">&times;</div>
            </div>
        </div>
        <div class="L_ProductDataHolder">
            <div class="G_DisplayRowNowrap L_ProductImageHolder">
                <div class="G_BorderRadius L_ProductImage" :style="{ backgroundImage: 'url(\''+ProductInfo.ImagePath+'\')' }"></div>
            </div>
            <div class="G_DisplayColumnNowrap L_ProductInfoHolder">
                <div class="G_DisplayRowNowrap G_HeadingFont L_ProductInfoHeading">
                    {{ ProductInfo.Description }}
                </div>
                <div class="G_DisplayColumnNowrap G_NormalFont L_ProductInfoDetails">
                    <div class="G_DisplayRowNowrap">
                        <div>-&nbsp;</div>
                        <div>R {{ ProductInfo.Price }}.</div>
                    </div>
                    <div class="G_DisplayRowNowrap">
                        <div>-&nbsp;</div>
                        <div>{{ ProductInfo.Pieces }}.</div>
                    </div>
                    <!-- <div class="G_DisplayRowNowrap"><div>-&nbsp;</div><div>Pickup is available at 12 Highveld Road, Kempton Park, 1620.</div></div> -->
                    <div class="G_DisplayRowNowrap">
                        <div>-&nbsp;</div>
                        <div>You will be contacted in regards to recieving/picking up of the order.</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>
</template>

<script>
export default {
    props: [
        "ShopItem",
        "ProductInfoData"
    ],
    data() {
        return {
            ProductInfo: {}
        }
    },
    created() {
        this.ProductInfo = JSON.parse(JSON.stringify(this.ProductInfoData))
    },
    methods: {
        close() {
            this.$emit('CloseProductInfo', '')
        }
    }
}
</script>

<style lang="scss">
@import "../../assets/GlobalCss.scss";

.L_PopupHolder {
    position: fixed;
    overflow-y: auto;
    top: 50%;
    left: 50%;
    transform: rotate(0deg) translate(-50%, -50%);
    padding: 5px;
    z-index: 10;
    box-shadow: 1px 1px 8px 0px rgba(0, 0, 0, 0.75);
    background-color: rgb(231, 231, 231);
    border-radius: 5px 5px 5px 5px;
    width: 60rem;
    justify-content: stretch;
    height: 40rem;
    background-color: #ffffff;

    @include mobile() {
        width: 95%;
        height: 25rem;
    }
}

.L_PopupHeading {
    width: 100%;
    height: 3.5rem;
    background-color: rgb(243, 203, 187);
    ;
    color: #FFFFFF;
    justify-content: space-between;
    align-items: center;
}

.L_ProductHeading {
    margin-left: .5rem;
}

.L_CloseButton {
    padding-right: 0.5rem;
    cursor: pointer;
}

.L_ProductDataHolder {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: center;
    align-items: center;
}

.L_ProductImageHolder {
    width: 50%;
    height: 100%;
    justify-content: center;
    align-items: center;
}

.L_ProductImage {
    width: 80%;
    height: 50%;
    background-size: 100% 100%;
}

.L_ProductInfoHolder {
    width: 50%;
    height: 70%;
}

.L_ProductInfoHeading {
    width: 100%;
    height: 15%;
    justify-content: center;
    align-items: center;
}
</style>
